import { render, staticRenderFns } from "./DocumentSelector.vue?vue&type=template&id=0f48a213&scoped=true&"
import script from "./DocumentSelector.vue?vue&type=script&lang=js&"
export * from "./DocumentSelector.vue?vue&type=script&lang=js&"
import style0 from "./DocumentSelector.vue?vue&type=style&index=0&id=0f48a213&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f48a213",
  null
  
)

export default component.exports